var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".delete_svg__cls-1{fill:#d8d8d8;opacity:.5}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "delete_svg__Ebene_1",
  "data-name": "Ebene 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "delete_svg__cls-1",
  d: "M8 13.76a.41.41 0 0 1-.41-.41V8.42a.41.41 0 1 1 .81 0v4.93a.4.4 0 0 1-.4.41ZM9.94 13.89h-.07a.42.42 0 0 1-.34-.47l.79-4.87a.4.4 0 0 1 .47-.33.41.41 0 0 1 .34.46l-.79 4.87a.42.42 0 0 1-.4.34ZM6 13.9a.4.4 0 0 1-.4-.34l-.81-4.87a.41.41 0 0 1 .33-.47.41.41 0 0 1 .47.34l.79 4.87a.42.42 0 0 1-.38.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "delete_svg__cls-1",
  d: "m6.06 5.77 7.47-2.2-.79-2.69-2.66.78-.08-.17L9.83.8 9.6 0l-.78.25-1 .28-2 .58-1 .28-.78.23.23.78.2.7v.17L2 4.05l.51 1.74.63 8.29a2 2 0 0 0 2 1.89h6a2 2 0 0 0 2-1.9l.59-8.3Zm0-3.88 2-.58 1-.28.2.69-3.91 1.15-.2-.7Zm6.09 0L12.52 3 3.31 5.73 3 4.6Zm0 12.15a1.17 1.17 0 0 1-1.17 1.11h-6A1.17 1.17 0 0 1 3.92 14l-.56-7.41h9.4Z"
}))));

export default SvgDelete;